<template>
    <div :class="['amount', size]">
        <slot v-if="!prefix" name="prefix"></slot>
        <span v-else>{{ prefix }}</span>
        {{ value }}
        <slot name="suffix"></slot>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        prefix: {
            type: String,
            default: '￥'
        },
        size: {
            type: String,
            default: 'big'
        }
    },
    computed: {
    }
};
</script>

<style lang="scss" scoped>
.amount {
    color: $-text-950;
    font-weight: bold;

    &.big {
        height: 28px;
        font-size: 28px;
        line-height: 28px;
    }

    &.samll {
        height: 14px;
        font-size: 14px;
        line-height: 14px;
    }

    span {
        font-size: 14px;
    }
}
</style>
